import { removeActivityForConversation } from "./activity";

/** Fired with { guid } whenever the current user no longer has access to a
 * group — left it, was kicked/banned, or it was deleted. Anything holding
 * a per-browser reference to that group (the Sidebar's starred list) should
 * listen for this and drop it, so there's no leftover path back into a
 * conversation that's no longer accessible. */
export const GROUP_REMOVED_EVENT = "dbm-group-removed";

/** Common cleanup for every "I no longer have this group" case — self-leave,
 * deleting a channel you own, or being kicked/banned by someone else.
 * Also re-triggers the existing sidebar refetch (dbm-channels-changed). */
export function purgeGroupReferences(guid: string): void {
  removeActivityForConversation("group", guid);
  window.dispatchEvent(new CustomEvent(GROUP_REMOVED_EVENT, { detail: { guid } }));
  window.dispatchEvent(new Event("dbm-channels-changed"));
}
